<template>
  <div class="content">

    <!--  查询  -->
    <el-form ref="form" :model="serchForm" :inline="true" label-width="auto" :rules="serchRules">
      <el-form-item style="width: 100%">
        <el-button type="primary" class="btn-add" @click="jumpXQ('new')" style="margin-left: 40px">添加项目
        </el-button>
        <el-button type="primary" class="btn-add" @click="showHeji"
                   style="background-color:rgb(238,204,120);border: rgb(247,192,137); box-shadow: 0px 3px 13px 0px rgba(243,196,158,0.38);margin-left: 40px ">
          合计
        </el-button>
        <el-button type="primary" class="btn-add" @click="serchData"
                   style="background-color:rgb(133,206,97);border: rgb(133,206,97); box-shadow: 0px 3px 13px 0px rgba(133,206,97, 0.38);margin-left: 40px">
          查询
        </el-button>
        <el-button type="primary" class="btn-add" @click="clearData"
                   style="background-color:rgb(247,137,137);border: rgb(247,137,137); box-shadow: 0px 3px 13px 0px rgba(247,137,137, 0.38);margin-left: 40px">
          清空查询
        </el-button>

      </el-form-item>
      <el-form-item label="项目名称：" prop="proname">
        <el-input style="width:200px" v-model="serchForm.proname" placeholder="请输入项目名称"></el-input>
      </el-form-item>
      <el-form-item label="负责人：" prop="personid">
                <el-select v-model="serchForm.person__id" filterable placeholder="请输入负责人" style="width:200px">
                  <el-option
                    v-for="item in userData"
                    :key="item.id"
                    :label="item.person"
                    :value="item.id">
                  </el-option>
                </el-select>
<!--        <el-cascader-->
<!--          placeholder="可搜索"-->
<!--          :options="options"-->
<!--          style="width:200px"-->
<!--          v-model="serchForm.person_id"-->
<!--          :props="{ multiple: true }"-->
<!--          filterable></el-cascader>-->
      </el-form-item>

      <el-form-item label="项目类别：" prop="project_type">
<!--        <el-input style="width:200px" v-model="serchForm.project_type" placeholder="请输入项目类别"></el-input>-->
        <el-select v-model="serchForm.project_type" placeholder="请选择项目类别" style="width:200px">
          <el-option
            v-for="item in leibie"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="甲方：" prop="jiafang">
        <el-input style="width:200px" v-model="serchForm.jiafang" placeholder="请输入甲方名称"></el-input>
      </el-form-item>
      <el-form-item label="甲方签约公司：" prop="jiafang_conpany">
        <el-input style="width:200px" v-model="serchForm.jiafang_conpany" placeholder="请输入甲方简称"></el-input>
      </el-form-item>
      <el-form-item label="签约公司：" prop="sign_company">
        <el-input style="width:200px" v-model="serchForm.sign_company" placeholder="请输入乙方简称"></el-input>
      </el-form-item>

      <el-form-item label="合同金额（万元）：" prop="contract_amount">
        <el-input style="width:200px;padding-right: 0px" v-model="serchForm.contract_amount" type="number"
                  placeholder="请输入合同金额"></el-input>
      </el-form-item>
      <el-form-item label="累计未收账款：" prop="department">
        <el-input style="width:200px" v-model="serchForm.accounts_receivable" placeholder="请输入累计未收账款">
        </el-input>
      </el-form-item>
<!--      <el-form-item label="累计开票：" prop="department">-->
<!--        <el-input style="width:200px" v-model="serchForm.invoice_amount" placeholder="请输入累计开票"></el-input>-->
<!--      </el-form-item>-->
<!--      <el-form-item label="累计开票未回款：" prop="department">-->
<!--        <el-input style="width:200px" v-model="serchForm.invoiced_uncollected_payment"-->
<!--                  placeholder="请输入开票未回款"></el-input>-->
<!--      </el-form-item>-->
<!--      <el-form-item label="商务用时：" prop="department">-->
<!--        <el-input style="width:200px" type="number" v-model="serchForm.business_time"-->
<!--                  placeholder="请输入商务用时（天）"></el-input>-->
<!--      </el-form-item>-->
<!--      <el-form-item label="实际服务时间：" prop="department">-->
<!--        <el-input style="width:200px" type="number" v-model="serchForm.service_time" placeholder="请输入实际服务时间"></el-input>-->
<!--      </el-form-item>-->

<!--      <el-form-item label="招投标/入库启动日期：" prop="warehousing_date">-->
<!--        <el-date-picker-->
<!--          v-model="serchForm.warehousing_date"-->
<!--          type="daterange"-->
<!--          range-separator="至"-->
<!--          start-placeholder="开始日期"-->
<!--          end-placeholder="结束日期"-->
<!--          style="width:300px"-->
<!--          value-format="yyyy-MM-dd"-->
<!--          placeholder="请选择日期">-->
<!--        </el-date-picker>-->
<!--      </el-form-item>-->

<!--      <el-form-item label="合同草拟日期：" prop="drafting_date">-->
<!--        <el-date-picker-->
<!--          v-model="serchForm.drafting_date"-->
<!--          type="daterange"-->
<!--          range-separator="至"-->
<!--          start-placeholder="开始日期"-->
<!--          end-placeholder="结束日期"-->
<!--          style="width:300px"-->
<!--          value-format="yyyy-MM-dd"-->
<!--          placeholder="请选择日期">-->
<!--        </el-date-picker>-->
<!--      </el-form-item>-->

<!--      <el-form-item label="合同签订日期：" prop="sign_date">-->
<!--        <el-date-picker-->
<!--          v-model="serchForm.sign_date"-->
<!--          value-format="yyyy-MM-dd"-->
<!--          style="width:300px"-->
<!--          type="daterange"-->
<!--          range-separator="至"-->
<!--          start-placeholder="开始日期"-->
<!--          end-placeholder="结束日期"-->
<!--          placeholder="请选择日期"-->
<!--        >-->
<!--        </el-date-picker>-->
<!--      </el-form-item>-->


<!--      <el-form-item label="项目启动日期：" prop="start_date">-->
<!--        <el-date-picker-->
<!--          v-model="serchForm.start_date"-->
<!--          type="daterange"-->
<!--          range-separator="至"-->
<!--          start-placeholder="开始日期"-->
<!--          end-placeholder="结束日期"-->
<!--          style="width:300px"-->
<!--          value-format="yyyy-MM-dd"-->
<!--          placeholder="请选择日期">-->
<!--        </el-date-picker>-->
<!--      </el-form-item>-->
<!--      <el-form-item label="项目关闭日期：" prop="closing_time">-->
<!--        <el-date-picker-->
<!--          v-model="serchForm.closing_time"-->
<!--          type="daterange"-->
<!--          range-separator="至"-->
<!--          start-placeholder="开始日期"-->
<!--          end-placeholder="结束日期"-->
<!--          style="width:300px"-->
<!--          value-format="yyyy-MM-dd"-->
<!--          placeholder="请选择日期">-->
<!--        </el-date-picker>-->
<!--      </el-form-item>-->

    </el-form>


    <el-table
      :data="tableData"
      border
      v-loading="loading"
      :header-cell-style="{ background: '#f6f9ff',color:'#7c8db5'}" :cell-style="{color:'#25396f'}"
    >
      <el-table-column
        label="项目名称"
        prop="proname"
        align="center"
      >
      </el-table-column>
      <el-table-column
        label="部门 - 负责人 - 权重占比"
        prop="person"
        align="center"
        min-width="300px"
      >
        <template slot-scope="scope">
<!--          <span v-if="index!=scope.row.proportion.length-1">；</span>-->
          <div style="white-space: nowrap" v-for="(item,index) in scope.row.proportion" :key="index">{{item.departemnts}} - {{ item.person }} - 权重占比:{{Number(item.propo*100).toFixed()}}% ;</div>
        </template>
      </el-table-column>

      <el-table-column label="项目类别" prop="project_type" align="center">
      </el-table-column>
      <el-table-column label="甲方" prop="jiafang" align="center">
      </el-table-column>
      <el-table-column label="甲方签约公司" prop="jiafang_conpany" align="center">
      </el-table-column>
      <el-table-column label="签约公司" prop="sign_company" align="center">
      </el-table-column>
      <el-table-column label="合同金额（万元）" prop="contract_amount" align="center">
      </el-table-column>

      <el-table-column label="累计未收账款（万元）" prop="accounts_receivable" align="center">
      </el-table-column>
      <el-table-column label="累计开票（万元）" prop="invoice_amount" align="center">
      </el-table-column>
      <el-table-column label="累计已回款（万元）" align="center">
        <template slot-scope="scope">
          {{(parseFloat(scope.row.contract_amount)-parseFloat(scope.row.accounts_receivable)).toFixed(2)}}
        </template>
      </el-table-column>
      <el-table-column label="累计开票未回款（万元）" prop="invoiced_uncollected_payment" align="center">
      </el-table-column>
      <el-table-column label="招投标/入库启动日期" prop="warehousing_date" align="center" min-width="120px">
      </el-table-column>
      <el-table-column label="合同草拟日期" prop="drafting_date" align="center" min-width="120px">
      </el-table-column>
      <el-table-column label="合同签订日期" prop="sign_date" align="center" min-width="120px">
      </el-table-column>
      <el-table-column label="项目启动订日期" prop="start_date" align="center" min-width="120px">
      </el-table-column>
      <el-table-column label="项目关闭日期" prop="closing_time" align="center" min-width="120px">
      </el-table-column>
      <el-table-column label="商务用时（天）" prop="business_time" align="center">
      </el-table-column>
      <el-table-column label="实际服务时间（天）" prop="service_time" align="center">
      </el-table-column>
      <el-table-column label="是否交付" prop="isdeliver" align="center">
        <template slot-scope="scope">
          {{ scope.row.isdeliver == 1 ? '已交付' : '未交付' }}
        </template>
      </el-table-column>

      <el-table-column label="操作" align="center" fixed="right">
        <template slot-scope="scope">
          <span class="caozuo" @click="hkjh(scope.row)" style="color:#347ae2;cursor: pointer;">回款计划</span>
          <span class="caozuo" @click="hkjh(scope.row)" style="color:#347ae2;cursor: pointer;">实际回款</span>
          <span class="caozuo" @click="hkjh(scope.row)" style="color:#347ae2;cursor: pointer;">开票时间</span>
          <span class="caozuo" @click="jumpXQ(scope.row.id)"
                style="color:#347ae2;cursor: pointer;">修改</span>
          <span class="caozuo" @click="delColomn(scope.row.id)" style="color:#ec4b4b;cursor: pointer;">删除</span>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      title="合计"
      :visible.sync="dialogVisible"
      width="50%"
      class="diago"
      :close-on-click-modal="false"
    >
      <el-table
        :data="xq_data"
        border
        :header-cell-style="{ background: '#f6f9ff',color:'#7c8db5'}" :cell-style="{color:'#25396f'}"
      >
        <el-table-column
          label="未收账款合计（万元）"
          prop="accounts_receivable_count"
          align="center"
        >
          <template slot-scope="scope">
            {{parseFloat(scope.row.accounts_receivable_count).toFixed(2)}}
          </template>
        </el-table-column>
        <el-table-column
          label="合同金额合计（万元）"
          prop="contract_amount_count"
          align="center"
        >
          <template slot-scope="scope">
            {{parseFloat(scope.row.contract_amount_count).toFixed(2)}}
          </template>
        </el-table-column>
        <el-table-column
          label="累计开票合计（万元）"
          prop="invoice_amount_count"
          align="center"
        >
          <template slot-scope="scope">
            {{parseFloat(scope.row.invoice_amount_count).toFixed(2)}}
          </template>
        </el-table-column>
        <el-table-column
          label="累计开票未回款合计（万元）"
          prop="invoiced_uncollected_payment_count"
          align="center"
        >
          <template slot-scope="scope">
            {{parseFloat(scope.row.invoiced_uncollected_payment_count).toFixed(2)}}
          </template>
        </el-table-column>

      </el-table>
    </el-dialog>

    <!--  分页  -->
    <Pagination
      v-if="total > 0"
      :currentPage="currentPage"
      :total="total"
      :limit="limit"
      @handleCurrentChange="handleCurrentChange">
    </Pagination>

  </div>
</template>
<script>
import {
  create_project,
  del_project,
  get_department,
  get_projectt,
  mod_project,
  get_collection_plan,
  filter, get_departments
} from "../../api/user";
import Pagination from "../../components/Pagination";

export default {


  data() {
    return {
      options: [],
      loading: false,
      tableData: [],
      currentPage: 1,
      userData: [],
      total: 0,
      limit: 10,
      //  弹窗参数
      title: '',
      dialogVisible: false,
      form: {
        projectid: '',
        personid: [],
        proname: '',
        project_type: '',
        jiafang: '',
        jiafang_conpany: '',
        sign_company: '',
        contract_amount: '',
        sign_date: '',
        start_date: '',
        accounts_receivable: '',
        // invoice_amount:'',
        invoiced_uncollected_payment: '',
        warehousing_date: '',
        drafting_date: '',
        closing_time: '',
        isdeliver: 0
      },
      leibie:[
        {
          value:'投资',
          label:'投资'
        },{
          value:'客研',
          label:'客研'
        },{
          value:'定位',
          label:'定位'
        },{
          value:'培训',
          label:'培训'
        },{
          value:'系统',
          label:'系统'
        },{
          value:'战略',
          label:'战略'
        },{
          value:'数据',
          label:'数据'
        },
      ],
      rules: {
        drafting_date: [
          {required: true, message: '请选择合同草拟日期', trigger: 'change'}
        ],
        closing_time: [
          {required: true, message: '请选择项目关闭日期', trigger: 'change'}
        ],
        proname: [
          {required: true, message: '请输入项目名称', trigger: 'change'}
        ],
        personid: [
          {required: true, message: '请选择负责人', trigger: 'change'}
        ],
        // sign_date: [
        //   {required: true, message: '请选择合同签订日期', trigger: 'change'}
        // ],
        project_type: [
          {required: true, message: '请输入项目类别', trigger: 'change'}
        ],
        jiafang: [
          {required: true, message: '请输入甲方', trigger: 'change'}
        ],
        jiafang_conpany: [
          {required: true, message: '请输入甲方签约公司', trigger: 'change'}
        ],
        sign_company: [
          {required: true, message: '请输入签约公司', trigger: 'change'}
        ],
        contract_amount: [
          {required: true, message: '请输入合同金额', trigger: 'change'}
        ],

      },
      // 查询data
      car: true,
      serchForm: {
        projectid: '',
        person__id: [],
        proname: '',
        project_type: '',
        jiafang: '',
        jiafang_conpany: '',
        sign_company: '',
        contract_amount: '',
        sign_date: '',
        start_date: '',
        accounts_receivable: '',
        invoice_amount: '',
        invoiced_uncollected_payment: '',
        warehousing_date: '',
        drafting_date: '',
        closing_time: '',
        service_time: '',
        business_time: ''
      },
      serchRules: {},
      //  是否执行过查询
      isSerch: false,
      depData: '',
      tableDatae: [],
      test: [{personid: 1, propo: 0.46}],
      xq_data:[]
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  methods: {
    //跳转至部门详情
    jumpXQ(id){
      this.$router.push({path:'/share/depart_xq',query:{id:id}})
    },
    showHeji(){
      this.dialogVisible = true
    },
    //清空查询
    clearData() {
      this.serchForm = {}
      this.serchData()
    },
    //查询表格
    serchData() {
      // this.isSerch = true
      this.loading = true
      let params = {}
      // if (this.serchForm.person_id.length != 0) {
      //   let newArr = []
      //   for (let i = 0; i < this.serchForm.person_id.length; i++) {
      //     let a = ''
      //     a = this.serchForm.person_id[i][this.serchForm.person_id.length - 1]
      //     newArr.push(a)
      //   }
      //   this.serchForm.person_id = newArr.join(',')
      // }
      for (const paramsKey in this.serchForm) {
        if (this.serchForm[paramsKey] != '') {
          if (paramsKey == 'sign_date' || paramsKey == 'start_date' || paramsKey == 'closing_time' || paramsKey == 'drafting_date' || paramsKey == 'warehousing_date') {
            params[paramsKey] = this.serchForm[paramsKey].join(',')
          } else if (paramsKey == 'business_time' || paramsKey == 'service_time') {
            params[paramsKey] = parseInt(this.serchForm[paramsKey])
          } else {
            params[paramsKey] = this.serchForm[paramsKey]
          }
        }
      }
      let data = {
        page: this.currentPage,
        limit: 10
      }

      data['postdata'] = params
      // console.log(data)
      data['postdata'] = JSON.stringify(data['postdata'])
      filter(data).then(res => {
        if (res.code === 200) {
          setTimeout(() => {
            this.loading = false
          }, 1000);
          this.tableData = res.data
          this.total = res.total
          this.limit = 10
          this.xq_data = []
          let item = {}
          item.accounts_receivable_count = res.accounts_receivable_count
          item.contract_amount_count = res.contract_amount_count
          item.invoice_amount_count = res.invoice_amount_count
          item.invoiced_uncollected_payment_count = res.invoiced_uncollected_payment_count
          this.xq_data.push(item)
          // this.limit = res.limit

        } else {
          this.loading = false
          this.$message.error(res.msg)
        }
      })

    },
    //查询开票时间
    kpsj(row) {
      this.$router.push({path: "/share/kpsj_xq", query: {id: row.id, name: row.proname}})
    },
    //查询回款计划
    hkjh(row) {
      this.$router.push({path: "/share/hkjh_xq", query: {id: row.id, name: row.proname}})
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      // if(this.isSerch){
      this.serchData()
      // }else{
      //   this.getData()
      // }
    },

    getUserData() {
      let params = {
        token: localStorage.getItem("token"),
        page: this.currentPage
      }
      return get_department(params).then(res => {

        if (res.code === 200) {
          // resolve(this.userData)
          // this.limit = res.data.per_page;
          // this.total = res.data.total;

          // return new Promise((resolve, reject)=>{
          this.userData = res.data;
          //   resolve(res.data)
          // })
        } else {
          this.$message.error(res.msg)
        }

      })
    },

    //  删除
    delColomn(row) {
      this.$confirm('确定删除该项目吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let params = {
            projectid: row
          }
          del_project(params).then(res => {
            if (res.code == 200) {
              this.$message.success('删除成功')
              this.serchData()
            } else {
              this.$message.error(res.msg)
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },


    //  获取负责人数据
    async getDept() {
      let params = {
        token: localStorage.getItem("token"),
        // page: this.currentPage,
        // limit:10
      }
      await get_departments(params).then(res => {
        if (res.code === 200) {
          this.depData = res.data;
          // this.limit = res.limit;
          // this.total = res.total;
        } else {
          this.$message.error(res.msg)
        }
      })
    },

    async getData() {
      let params = {
        token: localStorage.getItem("token"),
        // page: this.currentPage,
        // limit:10
      }
      await get_department(params).then(res => {
        if (res.code === 200) {
          this.userData = res.data;
          // console.log(res.data)

          this.tableDatae = res.data;
          let newArr = []
          for (let i = 0; i < this.tableDatae.length; i++) {
            for (let j = 0; j < this.depData.length; j++) {
              if (this.tableDatae[i].departments_id == this.depData[j].id) {
                // this.tableData[i].departments_id = this.depData[j].id
                this.tableDatae[i].department_name = this.depData[j].department_name
              }
            }
          }

          for (let i = 0; i < this.depData.length; i++) {
            let item = {
              id: this.depData[i].id,
              value: this.depData[i].id,
              label: this.depData[i].department_name,
              children: [],
              disabled: true
            }
            newArr.push(item)
          }

          for (let i = 0; i < this.tableDatae.length; i++) {
            for (let j = 0; j < newArr.length; j++) {
              if (this.tableDatae[i].departments_id == newArr[j].id) {
                let itema = {
                  value: this.tableDatae[i].id,
                  label: this.tableDatae[i].person
                }
                newArr[j].children.push(itema)
              }
            }
          }
          this.options = newArr

        } else {
          this.$message.error(res.msg)
        }
      })
    },
    async getAllData() {
      try {
        await this.getDept()
        await this.getData()
      } catch (e) {
      }
    },
  },
  mounted() {
    this.getAllData()
    this.serchData()
  }

}
</script>
<style>
.caozuo {
  white-space: nowrap;
}

.fzr >>> .el-checkbox__input .is-disabled {
  display: none;
}

.jiaofu >>> .el-form-item__content {
  height: 40px;
  line-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/views/share/current.vue